<template>
  <div class="page">
    <div class="content">
      <picture class="hero">
        <source
          srcset="@/assets/images/mobile/bg.webp"
          type="image/webp"
        />
        <img
          src="@/assets/images/mobile/bg.jpg"
          width="750"
          height="872"
          fetchpriority="high"
          alt=""
        />
      </picture>
      <img
        class="content-img"
        :src="Content"
        width="194"
        height="188"
        alt=""
      />
      <div class="btn-group">
        <picture>
          <source
            srcset="@/assets/images/mobile/google.webp"
            type="image/webp"
          />
          <img
            class="google"
            :src="Google"
            width="172"
            height="172"
            alt=""
            @click="toStore('android')"
          />
        </picture>
        <picture>
          <source
            srcset="@/assets/images/mobile/apple.webp"
            type="image/webp"
          />
          <img
            class="apple"
            :src="Apple"
            width="172"
            height="172"
            alt=""
            @click="toStore('ios')"
          />
        </picture>
        <picture>
          <source
            srcset="@/assets/images/mobile/android.webp"
            type="image/webp"
          />
          <img
            class="android"
            :src="Android"
            width="172"
            height="172"
            alt=""
            @click="$emit('download')"
          />
        </picture>
      </div>
      <img
        class="bg2-img"
        :src="bg2"
        width="750"
        height="3574"
        loading="lazy"
        decoding="async"
        alt=""
      />
      <div class="bottom-dl">
        <img
          class="bg3-img"
          :src="bg3"
          width="750"
          height="1568"
          loading="lazy"
          decoding="async"
          alt=""
        />
        <picture class="btn">
          <source
            srcset="@/assets/images/mobile/btn.webp"
            type="image/webp"
          />
          <img
            :src="btn"
            width="686"
            height="104"
            loading="lazy"
            decoding="async"
            alt=""
            @click="downloadApp()"
          />
        </picture>
      </div>
    </div>
  </div>
</template>

<script setup>
import Content from '@/assets/images/mobile/content.png';
import Android from '@/assets/images/mobile/android.png';
import Google from '@/assets/images/mobile/google.png';
import Apple from '@/assets/images/mobile/apple.png';
import bg2 from '@/assets/images/mobile/bg2.jpg';
import bg3 from '@/assets/images/mobile/bg3.jpg';
import btn from '@/assets/images/mobile/btn.png';
import { DownloadUrl } from '@local-utils/const';
import { downloadApp } from '@local-utils/common';

defineEmits(['download']);

function toStore(type) {
  if (type === 'ios') {
    window.open(DownloadUrl.ios);
  } else {
    window.open(DownloadUrl.android);
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';

.page {
  width: 100%;
  max-width: $mobile-max-width;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .content {
    position: relative;
    background: #ffffff;
    padding: 1.4rem 0 0;

    .hero {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      pointer-events: none;

      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }

    > :not(.hero) {
      position: relative;
    }

    .content-img {
      display: block;
      margin: 0 auto 2.7rem;
      width: 1.94rem;
      height: 1.88rem;
      object-fit: contain;
    }

    .btn-group {
      margin: 0 auto 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .android,
    .google,
    .apple {
      display: block;
      margin: auto 0.25rem;
      width: 1.72rem;
      height: 1.72rem;
      cursor: pointer;
      object-fit: contain;
    }

    .bg2-img,
    .bg3-img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .bottom-dl {
    position: relative;

    .btn {
      position: absolute;
      left: 50%;
      bottom: 1rem;
      transform: translateX(-50%);
      width: 6.86rem;
      height: 1.04rem;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
